import { Stack, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LogoRaw from "../assets/images/logo-raw.svg";
import { useApp } from "../contexts/AppContext";

const withAuthentication = <P extends object>(
  Component: React.ComponentType<P>
) => {
  console.info("withAuthentication");
  const AuthenticatedComponent: React.FC<P> = (props) => {
    const { user, checkUser } = useAuth();
    const location = useLocation();

    const effectRan = useRef(false);

    const { translate } = useApp();
    const translations = translate("general");

    useEffect(() => {
      if (effectRan.current === false) {
        console.info("useffetct withAuthentication", user);
        const verifyUser = async () => {
          console.info("useffetct user", user);
          await checkUser();
        };
        verifyUser();
        effectRan.current = true;
      }
    }, []);

    if (user === undefined) {
      return (
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          direction="row"
          gap={1}
          margin={"auto auto"}
        >
          <img src={LogoRaw} />
          <Typography variant="h6">{translations.loading}</Typography>
        </Stack>
      );
    }

    console.info("withAuthentication user", user);
    if (user === null) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (window.location.pathname !== "/signup/password" && user?.status === 2) {
      // use type
      return <Navigate to="/signup/password" />;
    }

    if (window.location.pathname === "/signup/password" && user?.status === 1) {
      return <Navigate to="/dashboard" />;
    }

    if (user?.role === 2 && window.location.pathname === "/manage") {
      return <Navigate to="/dashboard" />;
    }

    return <Component {...props} />;
  };

  return AuthenticatedComponent;
};

export default withAuthentication;
